export const CLOUDPAYMENTS_CONSTANTS = {
  CURRENCY: 'RUB',
  SCRIPT_URL: 'https://widget.cloudpayments.ru/bundles/cloudpayments.js',
} as const;
